<template>
  <div>
    <autocomplete-input
      :query="occasionQuery"
      :items="filteredOccasions"
      :placeholder="$store.state.localizedStrings.enterRaceName"
      :display-fn="displayOccasion"
      :input-class="inputClass"
      @update:query="onQueryUpdate"
      @input-changed="onInputChanged"
      @item-selected="onItemSelected"
    />
    <div
      v-if="showValidation"
      class="js-occasion-validation-msg"
    >
      <span class="find-your-photos-bar__fail">!</span>
      <div class="find-your-photos-bar__fail-message">{{ $store.state.localizedStrings.enterValidEvent }}</div>
    </div>
  </div>
</template>

<script>
import AutocompleteInput from './AutocompleteInput.vue'

export default {
  name: 'OccasionTypeahead',
  components: {
    AutocompleteInput: AutocompleteInput
  },
  computed: {
    occasionQuery: function () {
      return this.$store.state.occasionQuery
    },
    filteredOccasions: function () {
      var query = this.occasionQuery.toLowerCase().trim()
      if (query.length < 2) {
        return []
      }

      var queryTokens = query.split(/\s+/)
      var filtered = this.$store.state.occasions.filter(function (occasion) {
        var name = occasion.occasionNameWithYear.toLowerCase()
        var nameTokens = name.split(/\s+/)
        return queryTokens.every(function (qt) {
          return nameTokens.some(function (nt) {
            return nt.indexOf(qt) === 0
          })
        })
      })

      // Sort by year descending
      filtered.sort(function (a, b) {
        if (a.year < b.year) return 1
        if (a.year > b.year) return -1
        return 0
      })

      return filtered.slice(0, 20)
    },
    showValidation: function () {
      return this.$store.state.validationAttempted && !this.$store.getters.occasionValid
    },
    inputClass: function () {
      var classes = ['find-your-photos-bar__input', 'typeahead', 'typeahead-occasions']
      if (this.$store.state.validationAttempted) {
        if (this.$store.getters.occasionValid) {
          classes.push('find-your-photos-bar__input--success')
        } else {
          classes.push('find-your-photos-bar__input--fail')
        }
      }
      return classes
    }
  },
  mounted: function () {
    if (!this.$store.state.occasionsLoaded) {
      this.$store.dispatch('fetchOccasions')
    }
  },
  methods: {
    displayOccasion: function (occasion) {
      return occasion.occasionNameWithYear
    },
    onQueryUpdate: function (value) {
      this.$store.commit('setOccasionQuery', value)
    },
    onInputChanged: function () {
      // If the user types after selecting, clear the selection
      this.$store.commit('setSelectedOccasion', null)
    },
    onItemSelected: function (occasion) {
      // Check sportograf redirects
      window.sportografRedirects = window.sportografRedirects || []
      if (window.sportografRedirects[occasion.occasionRef] !== undefined) {
        window.location.href = window.sportografRedirects[occasion.occasionRef]
        return
      }

      this.$store.commit('setOccasionQuery', occasion.occasionNameWithYear)
      this.$store.commit('setSelectedOccasion', occasion)
      if (!occasion.requireExactMatch) {
        this.$store.dispatch('prefetchParticipants', occasion.occasionRef)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// WebResources/vue/find-my-photos/components/OccasionTypeahead.vue